<template>

    <v-card
        v-show="rewardPoints"
        flat
        :color="color"
        min-width="250"
        max-width="250"
        :style="panelRoundnessStyle(roundness)"
    >
        <!-- DESKTOP DEVICES -->
        <v-card-text class="d-none d-md-block display-2" :class="getFontClasses(color)">
            <div style="width: 200px">{{displayPoints}}</div>
            <div class="body-2">

                <!-- EDIT MODE -->
                <text-editor v-if="editMode"
                             v-model="rewardsEarnedTextModel"
                             hint="Rewards earned text"
                >

                            <span>
                                {{data.rewards_earned_text}}
                            </span>
                </text-editor>

                <!-- NON EDIT MODE -->
                <div v-if="!editMode">
                    {{rewardsEarnedText}}
                </div>
            </div>
        </v-card-text>

        <!-- DISPLAY ONLY ON THE MOBILE DEVICES, MORE COMPACT -->
        <v-card-text class="d-md-none text-h6" :class="getFontClasses(color)">
            {{data.rewards_earned_text}}
            {{displayPoints.toLocaleString()}}
        </v-card-text>
    </v-card>
</template>

<script>

    import TextEditor from "@/components/UI/TextEditor.vue";
    import colorMixin from "@/components/mixins/colorMixin.js";
    import panelRoundnessMixin from "@/components/mixins/panelRoundnessMixin";

    export default {

        mixins: [
            colorMixin,
            panelRoundnessMixin,
        ],

        components: {
            TextEditor
        },

        props: {
            editMode: {
                type: Boolean,
                required: false,
                default: false,
            },
            color: {
                type: String,
                required: true,
            },
            rewardPoints: {
                type: Number | null,
                required: true,
            },
            rewardsEarnedText: {
                type: String,
                required: true,
            },
            roundness: {
                type: Number,
                required: false,
                default: 33,
            },
        },

        data() {
            return {
                displayPoints: 0,
                animationTimer: null,
                data: {
                    rewards_earned_text: null,
                }
            }
        },

        watch: {
            rewardPoints(points) {
                this.animate(points);
            },
        },

        methods: {
            animate(points = 0) {

                let timeout = 10;
                let step = Math.ceil(points / 100);

                this.animationTimer = setInterval(() => {
                    if (this.displayPoints < this.rewardPoints) {
                        this.displayPoints += step;
                        if (this.displayPoints > this.rewardPoints) this.displayPoints = this.rewardPoints;
                    } else {
                        clearInterval(this.animationTimer);
                    }
                }, timeout);
            }
        },

        mounted() {
            this.data.rewards_earned_text = this.rewardsEarnedText;
            this.displayPoints = 0;
            this.animate(this.rewardPoints);
        },

        computed: {
            rewardsEarnedTextModel: {
                get() {
                    this.data.rewards_earned_text = this.rewardsEarnedText;
                    return this.rewardsEarnedText;
                },
                set(value) {
                    this.data.rewards_earned_text = value;
                    this.$emit('change:subPanelTranslations', this.data);
                }
            },
        },
    }
</script>
